// extracted by mini-css-extract-plugin
export default {"wrapper":"PremiumSelector_wrapper__-dt4e","select":"PremiumSelector_select__-nSCF","mark":"PremiumSelector_mark__Pc66r"};